<template>
    <EditModal
        v-model:open="isVisible"
        :title="editingChapterId ? '編輯章節' : '新增章節'"
        :confirm-loading="confirmLoading"
        :width="1000"
        @ok="handleSubmit"
        @cancel="handleCancel"
    >
        <template #form>
            <a-form
                ref="formRef"
                :model="formData"
                :rules="formRules"
                autocomplete="off"
                layout="vertical"
            >
                <a-collapse
                    v-model:activeKey="sectionsActiveKeys"
                    :bordered="false"
                    class="form-sections-collapse"
                >
                    <!-- 基本資訊區塊 -->
                    <a-collapse-panel key="basic" class="form-section-panel">
                        <template #header>
                            <span class="section-header">基本資訊</span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-row :gutter="16">
                                <!-- 左側：基本資料 -->
                                <a-col :span="12">
                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item
                                                label="名稱"
                                                name="name"
                                            >
                                                <a-input
                                                    v-model:value="
                                                        formData.name
                                                    "
                                                    placeholder="請輸入名稱"
                                                />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item
                                                label="屬性"
                                                name="attribute"
                                            >
                                                <a-select
                                                    v-model:value="
                                                        formData.attribute
                                                    "
                                                    placeholder="請選擇屬性"
                                                >
                                                    <a-select-option
                                                        v-for="attr in missionOptions.attributes"
                                                        :key="attr.value"
                                                        :value="attr.value"
                                                    >
                                                        {{ attr.label }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-form-item
                                        label="描述"
                                        name="description"
                                    >
                                        <a-textarea
                                            v-model:value="formData.description"
                                            :rows="3"
                                            placeholder="請輸入描述"
                                        />
                                    </a-form-item>
                                    <a-row :gutter="16">
                                        <a-col :span="12">
                                            <a-form-item label="狀態">
                                                <a-select
                                                    v-model:value="
                                                        formData.is_active
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        啟用
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        停用
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-item label="達成即完成">
                                                <a-select
                                                    v-model:value="
                                                        formData.auto_complete
                                                    "
                                                    style="width: 100%"
                                                >
                                                    <a-select-option
                                                        :value="true"
                                                    >
                                                        是
                                                    </a-select-option>
                                                    <a-select-option
                                                        :value="false"
                                                    >
                                                        否
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                    <a-row :gutter="16">
                                        <a-col :span="24">
                                            <a-form-item
                                                name="unlock_from_node_id"
                                            >
                                                <template #label>
                                                    前置任務
                                                </template>
                                                <input
                                                    type="text"
                                                    :id="`chapter-unlock-from-node-${formData.id || 'new'}`"
                                                    :value="
                                                        formData.unlock_from_node_id
                                                    "
                                                    readonly
                                                    tabindex="-1"
                                                    style="
                                                        position: absolute;
                                                        opacity: 0;
                                                        pointer-events: none;
                                                        width: 0;
                                                        height: 0;
                                                    "
                                                />
                                                <div
                                                    v-if="
                                                        formData.unlock_from_node_id
                                                    "
                                                    class="node-selector-display"
                                                    @click="
                                                        () =>
                                                            $emit(
                                                                'open-node-selector',
                                                                'unlock-source',
                                                                false,
                                                                formData
                                                            )
                                                    "
                                                >
                                                    <a-tag
                                                        closable
                                                        @close.stop="
                                                            (e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                formData.unlock_from_node_id =
                                                                    undefined;
                                                            }
                                                        "
                                                        color="green"
                                                        class="node-tag"
                                                    >
                                                        {{
                                                            unlockFromNodeLabel ||
                                                            formData.unlock_from_node_name ||
                                                            getNodeName(
                                                                formData.unlock_from_node_id
                                                            ) ||
                                                            formData.unlock_from_node_id
                                                        }}
                                                    </a-tag>
                                                </div>
                                                <a-button
                                                    v-else
                                                    type="dashed"
                                                    @click="
                                                        () =>
                                                            $emit(
                                                                'open-node-selector',
                                                                'unlock-source',
                                                                false,
                                                                formData
                                                            )
                                                    "
                                                    class="node-selector-btn"
                                                >
                                                    選擇前置任務
                                                </a-button>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-col>
                                <!-- 右側：時間設定與觸發設定 -->
                                <a-col :span="12">
                                    <a-form-item
                                        label="開始時間"
                                        name="start_time"
                                    >
                                        <a-date-picker
                                            v-model:value="formData.start_time"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            placeholder="請選擇開始時間（選填）"
                                            :disabled-date="
                                                startTimeDisabledDate
                                            "
                                            style="width: 100%"
                                            @change="
                                                (d) => {
                                                    formData.start_time =
                                                        applyStartOfDay(d);
                                                }
                                            "
                                        />
                                    </a-form-item>
                                    <a-form-item
                                        label="結束時間"
                                        name="end_time"
                                    >
                                        <a-date-picker
                                            v-model:value="formData.end_time"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            placeholder="請選擇結束時間（選填）"
                                            :disabled-date="endTimeDisabledDate"
                                            style="width: 100%"
                                            @change="
                                                (d) => {
                                                    formData.end_time =
                                                        applyEndOfDay(d);
                                                }
                                            "
                                        />
                                    </a-form-item>
                                    <a-form-item name="trigger_node_ids">
                                        <template #label>完成後觸發</template>
                                        <input
                                            type="text"
                                            :id="`chapter-trigger-nodes-${formData.id || 'new'}`"
                                            :value="
                                                formData.trigger_node_ids?.join(
                                                    ','
                                                ) || ''
                                            "
                                            readonly
                                            tabindex="-1"
                                            style="
                                                position: absolute;
                                                opacity: 0;
                                                pointer-events: none;
                                                width: 0;
                                                height: 0;
                                            "
                                        />
                                        <div
                                            v-if="
                                                formData.trigger_node_ids &&
                                                formData.trigger_node_ids
                                                    .length > 0
                                            "
                                            class="node-selector-display multiple"
                                            @click="
                                                () =>
                                                    $emit(
                                                        'open-node-selector',
                                                        'unlock',
                                                        true,
                                                        formData
                                                    )
                                            "
                                        >
                                            <a-tag
                                                v-for="(
                                                    nodeId, index
                                                ) in formData.trigger_node_ids"
                                                :key="index"
                                                closable
                                                @close.stop="
                                                    (e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        formData.trigger_node_ids.splice(
                                                            index,
                                                            1
                                                        );
                                                    }
                                                "
                                                color="blue"
                                                class="node-tag"
                                            >
                                                {{
                                                    formData.trigger_node_names[
                                                        nodeId
                                                    ] ||
                                                    getNodeName(nodeId) ||
                                                    nodeId
                                                }}
                                            </a-tag>
                                        </div>
                                        <a-button
                                            v-else
                                            type="dashed"
                                            @click="
                                                () =>
                                                    $emit(
                                                        'open-node-selector',
                                                        'unlock',
                                                        true,
                                                        formData
                                                    )
                                            "
                                            class="node-selector-btn"
                                        >
                                            選擇觸發任務
                                        </a-button>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 可見性規則區塊 -->
                    <a-collapse-panel
                        key="visibility"
                        class="form-section-panel"
                    >
                        <template #header>
                            <span class="section-header">
                                誰可以看到
                                <span class="section-note">
                                    （如果沒有設定則無限制）
                                </span>
                            </span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rules-section">
                                    <div class="rules-header">
                                        <a-button
                                            type="dashed"
                                            @click="addVisibilityRule"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增誰可以看到設定
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.visibility_rules &&
                                            formData.visibility_rules.length > 0
                                        "
                                        class="rules-list"
                                    >
                                        <div
                                            v-for="(
                                                rule, index
                                            ) in formData.visibility_rules"
                                            :key="index"
                                            class="rule-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="10">
                                                    <a-select
                                                        v-model:value="
                                                            rule.audience_type
                                                        "
                                                        placeholder="選擇誰可以看到"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            () =>
                                                                handleRuleTypeChange(
                                                                    'visibility',
                                                                    index
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.visibility_audience_types"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <a-select
                                                        v-if="
                                                            (
                                                                getVisibilityTypeOptions(
                                                                    rule.audience_type
                                                                ) || []
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        :placeholder="
                                                            getVisibilityPlaceholder(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    >
                                                        <a-select-option
                                                            v-for="opt in getVisibilityTypeOptions(
                                                                rule.audience_type
                                                            )"
                                                            :key="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value
                                                            "
                                                            :value="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value ||
                                                                opt.name
                                                            "
                                                        >
                                                            {{
                                                                opt.label ||
                                                                opt.name
                                                            }}
                                                        </a-select-option>
                                                    </a-select>
                                                    <a-select
                                                        v-else-if="
                                                            rule.audience_type ===
                                                            'user'
                                                        "
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        :filter-option="false"
                                                        :options="
                                                            getUserSearchOptions(
                                                                'visibility',
                                                                index
                                                            )
                                                        "
                                                        :loading="
                                                            getUserSearchLoading(
                                                                'visibility',
                                                                index
                                                            )
                                                        "
                                                        placeholder="搜尋會員名稱（可多選）"
                                                        style="width: 100%"
                                                        @search="
                                                            (val) =>
                                                                handleUserSearch(
                                                                    'visibility',
                                                                    index,
                                                                    val
                                                                )
                                                        "
                                                    ></a-select>
                                                    <a-input
                                                        v-else
                                                        v-model:value="
                                                            rule.audience_ref
                                                        "
                                                        :placeholder="
                                                            getVisibilityInputPlaceholder(
                                                                rule.audience_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    />
                                                </a-col>
                                                <a-col :span="2">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeVisibilityRule(
                                                                index
                                                            )
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rules">
                                        <a-empty
                                            description="尚未設定誰可以看到"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 可執行規則區塊 -->
                    <a-collapse-panel
                        key="executable"
                        class="form-section-panel"
                    >
                        <template #header>
                            <span class="section-header">
                                誰可以執行
                                <span class="section-note">
                                    （如果沒有設定則無限制）
                                </span>
                            </span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rules-section">
                                    <div class="rules-header">
                                        <a-button
                                            type="dashed"
                                            @click="addExecutableRule"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增誰可以執行設定
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.executable_rules &&
                                            formData.executable_rules.length > 0
                                        "
                                        class="rules-list"
                                    >
                                        <div
                                            v-for="(
                                                rule, index
                                            ) in formData.executable_rules"
                                            :key="index"
                                            class="rule-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="10">
                                                    <a-select
                                                        v-model:value="
                                                            rule.actor_type
                                                        "
                                                        placeholder="選擇誰可以執行"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            () =>
                                                                handleRuleTypeChange(
                                                                    'executable',
                                                                    index
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.executable_actor_types"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <a-select
                                                        v-if="
                                                            (
                                                                getExecutableTypeOptions(
                                                                    rule.actor_type
                                                                ) || []
                                                            ).length > 0
                                                        "
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        mode="multiple"
                                                        :placeholder="
                                                            getExecutablePlaceholder(
                                                                rule.actor_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    >
                                                        <a-select-option
                                                            v-for="opt in getExecutableTypeOptions(
                                                                rule.actor_type
                                                            )"
                                                            :key="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value
                                                            "
                                                            :value="
                                                                opt.id ||
                                                                opt.code ||
                                                                opt.value ||
                                                                opt.name
                                                            "
                                                        >
                                                            {{
                                                                opt.label ||
                                                                opt.name
                                                            }}
                                                        </a-select-option>
                                                    </a-select>
                                                    <a-select
                                                        v-else-if="
                                                            rule.actor_type ===
                                                            'user'
                                                        "
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        mode="multiple"
                                                        show-search
                                                        :filter-option="false"
                                                        :options="
                                                            getUserSearchOptions(
                                                                'executable',
                                                                index
                                                            )
                                                        "
                                                        :loading="
                                                            getUserSearchLoading(
                                                                'executable',
                                                                index
                                                            )
                                                        "
                                                        placeholder="搜尋會員名稱（可多選）"
                                                        style="width: 100%"
                                                        @search="
                                                            (val) =>
                                                                handleUserSearch(
                                                                    'executable',
                                                                    index,
                                                                    val
                                                                )
                                                        "
                                                    ></a-select>
                                                    <a-input
                                                        v-else
                                                        v-model:value="
                                                            rule.actor_ref
                                                        "
                                                        :placeholder="
                                                            getExecutableInputPlaceholder(
                                                                rule.actor_type
                                                            )
                                                        "
                                                        style="width: 100%"
                                                    />
                                                </a-col>
                                                <a-col :span="2">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeExecutableRule(
                                                                index
                                                            )
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rules">
                                        <a-empty
                                            description="尚未設定誰可以執行"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>

                    <!-- 獎勵設定區塊 -->
                    <a-collapse-panel key="rewards" class="form-section-panel">
                        <template #header>
                            <span class="section-header">獎勵設定</span>
                        </template>
                        <a-card
                            class="form-section-card-inner"
                            :bordered="false"
                        >
                            <a-form-item>
                                <div class="rewards-section">
                                    <div class="rewards-header">
                                        <a-button
                                            type="dashed"
                                            @click="addReward"
                                            size="small"
                                        >
                                            <template #icon>
                                                <PlusOutlined />
                                            </template>
                                            新增獎勵
                                        </a-button>
                                    </div>
                                    <div
                                        v-if="
                                            formData.rewards &&
                                            formData.rewards.length > 0
                                        "
                                        class="rewards-list"
                                    >
                                        <div
                                            v-for="(
                                                reward, index
                                            ) in formData.rewards"
                                            :key="index"
                                            class="reward-item"
                                        >
                                            <a-row :gutter="16" align="middle">
                                                <a-col :span="8">
                                                    <a-select
                                                        v-model:value="
                                                            reward.reference_id
                                                        "
                                                        placeholder="選擇獎勵類型"
                                                        style="width: 100%"
                                                        autocomplete="off"
                                                        data-lpignore="true"
                                                        data-form-type="other"
                                                        @change="
                                                            (value) =>
                                                                handleRewardTypeChange(
                                                                    index,
                                                                    value
                                                                )
                                                        "
                                                    >
                                                        <a-select-option
                                                            v-for="option in missionOptions.rewardTypes"
                                                            :key="option.value"
                                                            :value="
                                                                option.value
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-col>
                                                <a-col :span="12">
                                                    <a-input-number
                                                        v-model:value="
                                                            reward.value
                                                        "
                                                        placeholder="獎勵數量"
                                                        style="width: 100%"
                                                        :min="0"
                                                    />
                                                </a-col>
                                                <a-col :span="4">
                                                    <a-button
                                                        type="text"
                                                        @click="
                                                            removeReward(index)
                                                        "
                                                        size="small"
                                                        class="delete-rule-btn"
                                                    >
                                                        <template #icon>
                                                            <DeleteOutlined />
                                                        </template>
                                                    </a-button>
                                                </a-col>
                                            </a-row>
                                        </div>
                                    </div>
                                    <div v-else class="no-rewards">
                                        <a-empty
                                            description="尚未設定獎勵"
                                            :image="false"
                                        />
                                    </div>
                                </div>
                            </a-form-item>
                        </a-card>
                    </a-collapse-panel>
                </a-collapse>
            </a-form>
        </template>
    </EditModal>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick } from 'vue';
import { message } from 'ant-design-vue';
import { showErrorMessage } from '@/utils/messageHelper';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import EditModal from '@/components/common/EditModal.vue';
import { getChapterDetail, createChapter, updateChapter } from '@/api/missions';
import { searchUsers } from '@/api/users';
import { handleHttpError } from '@/api/errorHandler';
import dayjs from 'dayjs';
import { applyStartOfDay, applyEndOfDay } from '@/utils/dateTimePicker';
import { processSubmitData } from './missionFormUtils';

// Props
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    editingId: {
        type: Number,
        default: null
    },
    missionId: {
        type: Number,
        required: true
    },
    missionOptions: {
        type: Object,
        required: true
    },
    confirmLoading: {
        type: Boolean,
        default: false
    },
    missionTimeRange: {
        type: Object,
        default: null
    },
    nodeNameMap: {
        type: Object,
        default: () => ({})
    },
    unlockFromNodeLabel: {
        type: String,
        default: ''
    },
    triggeredByNodeLabel: {
        type: String,
        default: ''
    }
});

// Emits
const emit = defineEmits([
    'update:modelValue',
    'update:editingId',
    'success',
    'open-node-selector'
]);

// Refs
const formRef = ref(null);
const sectionsActiveKeys = ref([
    'basic',
    'visibility',
    'executable',
    'rewards'
]);

// Form data
const formData = reactive({
    mission_id: props.missionId,
    name: '',
    description: '',
    attribute: undefined,
    is_active: true,
    auto_complete: false,
    is_trigger: false,
    triggered_by_id: undefined,
    unlock_from_node_id: undefined,
    unlock_from_node_name: undefined, // 保存解鎖來源節點的名稱
    trigger_node_ids: [],
    trigger_node_names: {}, // 保存觸發節點 ID 到名稱的映射
    designated_collaborator: [],
    start_time: undefined,
    end_time: undefined,
    visibility_rules: [],
    executable_rules: [],
    rewards: []
});

// Form rules
const formRules = {
    name: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
    attribute: [{ required: true, message: '請選擇屬性', trigger: 'change' }]
};

// 用戶搜尋相關
const userSearchState = reactive({
    visibility: {},
    executable: {}
});

const userSearchLoading = reactive({
    visibility: {},
    executable: {}
});

// Computed
const isVisible = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
});

const editingChapterId = computed({
    get: () => props.editingId,
    set: (val) => emit('update:editingId', val)
});

// 時間限制函數
const startTimeDisabledDate = (current) => {
    if (!current) return false;
    if (
        props.missionTimeRange?.start &&
        current < dayjs(props.missionTimeRange.start)
    ) {
        return true;
    }
    if (
        props.missionTimeRange?.end &&
        current > dayjs(props.missionTimeRange.end)
    ) {
        return true;
    }
    if (formData.end_time && current > dayjs(formData.end_time)) {
        return true;
    }
    return false;
};

const endTimeDisabledDate = (current) => {
    if (!current) return false;
    if (
        props.missionTimeRange?.start &&
        current < dayjs(props.missionTimeRange.start)
    ) {
        return true;
    }
    if (
        props.missionTimeRange?.end &&
        current > dayjs(props.missionTimeRange.end)
    ) {
        return true;
    }
    if (formData.start_time && current < dayjs(formData.start_time)) {
        return true;
    }
    return false;
};

// 節點名稱
const getNodeName = (nodeId) => {
    return props.nodeNameMap[nodeId] || '';
};

// 規則處理
const addVisibilityRule = () => {
    formData.visibility_rules.push({
        audience_type: undefined,
        audience_ref: []
    });
};

const removeVisibilityRule = (index) => {
    formData.visibility_rules.splice(index, 1);
};

const addExecutableRule = () => {
    formData.executable_rules.push({
        actor_type: undefined,
        actor_ref: []
    });
};

const removeExecutableRule = (index) => {
    formData.executable_rules.splice(index, 1);
};

const handleRuleTypeChange = (ruleType, index) => {
    if (ruleType === 'visibility') {
        formData.visibility_rules[index].audience_ref = [];
    } else {
        formData.executable_rules[index].actor_ref = [];
    }
};

// 獎勵處理
const addReward = () => {
    formData.rewards.push({
        reward_type: 'point',
        reference_id: undefined,
        value: undefined
    });
};

const removeReward = (index) => {
    formData.rewards.splice(index, 1);
};

const handleRewardTypeChange = (index, value) => {
    const reward = formData.rewards[index];
    if (value === 'exp') {
        reward.reward_type = 'exp';
        reward.reference_id = undefined;
    } else {
        reward.reward_type = 'point';
        reward.reference_id = value;
    }
};

// 用戶搜尋
const getUserSearchOptions = (type, index) => {
    return userSearchState[type]?.[index] || [];
};

const getUserSearchLoading = (type, index) => {
    return userSearchLoading[type]?.[index] || false;
};

const handleUserSearch = async (type, index, keyword) => {
    if (!keyword || keyword.trim() === '') {
        userSearchState[type][index] = [];
        return;
    }

    try {
        userSearchLoading[type][index] = true;
        const response = await searchUsers({ name: keyword.trim() });
        userSearchState[type][index] = response.data.map((user) => ({
            label: user.name || user.username,
            value: user.id
        }));
    } catch (error) {
        handleHttpError(error, '搜尋會員');
    } finally {
        userSearchLoading[type][index] = false;
    }
};

// 規則選項相關函數
const getVisibilityTypeOptions = (audienceType) => {
    if (!audienceType) return [];
    // 從 visibility_audience_types 中找到對應類型的 options
    const typeConfig = props.missionOptions.visibility_audience_types?.find(
        (type) => type.value === audienceType
    );
    return typeConfig?.options || [];
};

const getExecutableTypeOptions = (actorType) => {
    if (!actorType) return [];
    // 從 executable_actor_types 中找到對應類型的 options
    const typeConfig = props.missionOptions.executable_actor_types?.find(
        (type) => type.value === actorType
    );
    return typeConfig?.options || [];
};

const getVisibilityPlaceholder = (audienceType) => {
    const placeholders = {
        role: '選擇角色',
        department: '選擇事業部',
        rank: '選擇聘階',
        user: '搜尋會員'
    };
    return placeholders[audienceType] || '請選擇';
};

const getExecutablePlaceholder = (actorType) => {
    const placeholders = {
        role: '選擇角色',
        department: '選擇事業部',
        rank: '選擇聘階',
        user: '搜尋會員'
    };
    return placeholders[actorType] || '請選擇';
};

const getVisibilityInputPlaceholder = (audienceType) => {
    return '請輸入';
};

const getExecutableInputPlaceholder = (actorType) => {
    return '請輸入';
};

// 重置表單
const resetForm = () => {
    formData.mission_id = props.missionId;
    formData.name = '';
    formData.description = '';
    formData.attribute = undefined;
    formData.is_active = true;
    formData.auto_complete = false;
    formData.is_trigger = false;
    formData.triggered_by_id = undefined;
    formData.unlock_from_node_id = undefined;
    formData.unlock_from_node_name = undefined;
    formData.trigger_node_ids = [];
    formData.trigger_node_names = {};
    formData.designated_collaborator = [];
    formData.start_time = undefined;
    formData.end_time = undefined;
    formData.visibility_rules = [];
    formData.executable_rules = [];
    formData.rewards = [];

    // 重置用戶搜尋狀態
    userSearchState.visibility = {};
    userSearchState.executable = {};
    userSearchLoading.visibility = {};
    userSearchLoading.executable = {};

    nextTick(() => {
        formRef.value?.clearValidate();
    });
};

// 載入資料
const loadData = async (id) => {
    try {
        const response = await getChapterDetail(id);
        const data = response.data;

        formData.mission_id = data.mission_id;
        formData.name = data.name;
        formData.description = data.description || '';
        formData.attribute = data.attribute;
        formData.is_active = data.is_active;
        formData.auto_complete = data.auto_complete || false;
        formData.is_trigger = data.is_trigger || false;
        formData.triggered_by_id = data.triggered_by_id;
        formData.unlock_from_node_id = data.unlock_from_node_id;
        // 保存解鎖來源節點的名稱（用於顯示）
        formData.unlock_from_node_name = data.unlock_from_node?.name || null;
        formData.trigger_node_ids = data.trigger_node_ids || [];
        // 保存觸發節點的名稱映射（用於顯示）
        formData.trigger_node_names = {};
        if (data.trigger_nodes && Array.isArray(data.trigger_nodes)) {
            data.trigger_nodes.forEach((node) => {
                if (node.id && node.name) {
                    formData.trigger_node_names[node.id] = node.name;
                }
            });
        }
        // 處理 designated_collaborator：支援單值或陣列
        if (data.designated_collaborator) {
            formData.designated_collaborator = Array.isArray(
                data.designated_collaborator
            )
                ? data.designated_collaborator
                : [data.designated_collaborator];
        } else {
            formData.designated_collaborator = [];
        }
        formData.start_time = data.start_time
            ? dayjs(data.start_time)
            : undefined;
        formData.end_time = data.end_time ? dayjs(data.end_time) : undefined;

        // 處理可見性規則
        formData.visibility_rules =
            data.visibility_rules?.map((rule, ruleIndex) => {
                let audienceRef = [];
                if (rule.audience_ref) {
                    const refArray = Array.isArray(rule.audience_ref)
                        ? rule.audience_ref
                        : rule.audience_ref.split(',');

                    // 處理名稱字串（可能包含多個名稱，用逗號分隔）
                    const names = rule.audience_name
                        ? rule.audience_name.split(',').map((n) => n.trim())
                        : [];

                    // 根據 audience_type 找到對應的選項
                    const typeConfig =
                        props.missionOptions.visibility_audience_types?.find(
                            (type) => type.value === rule.audience_type
                        );
                    const options = typeConfig?.options || [];

                    if (options.length > 0) {
                        // 根據選項的 value 類型來轉換
                        audienceRef = refArray.map((ref) => {
                            // 嘗試在選項中找到匹配的項目
                            const matchedOption = options.find((opt) => {
                                const optValue =
                                    opt.id || opt.code || opt.value || opt.name;
                                return String(optValue) === String(ref);
                            });

                            if (matchedOption) {
                                return (
                                    matchedOption.id ||
                                    matchedOption.code ||
                                    matchedOption.value ||
                                    matchedOption.name
                                );
                            }
                            return ref;
                        });
                    } else if (rule.audience_type === 'user') {
                        // 對於 user 類型，需要將名稱加入到搜尋選項中
                        audienceRef = refArray.map((ref, refIndex) => {
                            const name = names[refIndex] || ref;

                            // 初始化搜尋選項
                            if (!userSearchState.visibility[ruleIndex]) {
                                userSearchState.visibility[ruleIndex] = [];
                            }

                            // 如果選項中還沒有這個 ID，則加入
                            const existingOption = userSearchState.visibility[
                                ruleIndex
                            ].find((opt) => opt.value === ref);
                            if (!existingOption) {
                                userSearchState.visibility[ruleIndex].push({
                                    label: name,
                                    value: ref
                                });
                            } else {
                                // 更新現有選項的 label
                                existingOption.label = name;
                            }

                            return ref;
                        });
                    } else {
                        // 對於其他類型，保持原始值
                        audienceRef = refArray;
                    }
                }

                return {
                    audience_type: rule.audience_type,
                    audience_ref: audienceRef
                };
            }) || [];

        // 處理可執行規則
        formData.executable_rules =
            data.executable_rules?.map((rule, ruleIndex) => {
                let actorRef = [];
                if (rule.actor_ref) {
                    const refArray = Array.isArray(rule.actor_ref)
                        ? rule.actor_ref
                        : rule.actor_ref.split(',');

                    // 處理名稱字串（可能包含多個名稱，用逗號分隔）
                    const names = rule.actor_name
                        ? rule.actor_name.split(',').map((n) => n.trim())
                        : [];

                    // 根據 actor_type 找到對應的選項，確保值類型匹配
                    const typeConfig =
                        props.missionOptions.executable_actor_types?.find(
                            (type) => type.value === rule.actor_type
                        );
                    const options = typeConfig?.options || [];

                    if (options.length > 0) {
                        // 根據選項的 value 類型來轉換，確保能正確匹配
                        actorRef = refArray.map((ref) => {
                            // 嘗試在選項中找到匹配的項目
                            const matchedOption = options.find((opt) => {
                                const optValue =
                                    opt.id || opt.code || opt.value || opt.name;
                                return String(optValue) === String(ref);
                            });

                            if (matchedOption) {
                                // 返回選項的實際 value（用於綁定）
                                return (
                                    matchedOption.id ||
                                    matchedOption.code ||
                                    matchedOption.value ||
                                    matchedOption.name
                                );
                            }

                            // 如果找不到匹配，保持原始值
                            return ref;
                        });
                    } else if (rule.actor_type === 'user') {
                        // 對於 user 類型，需要將名稱加入到搜尋選項中
                        actorRef = refArray.map((ref, refIndex) => {
                            const name = names[refIndex] || ref;

                            // 初始化搜尋選項
                            if (!userSearchState.executable[ruleIndex]) {
                                userSearchState.executable[ruleIndex] = [];
                            }

                            // 如果選項中還沒有這個 ID，則加入
                            const existingOption = userSearchState.executable[
                                ruleIndex
                            ].find((opt) => opt.value === ref);
                            if (!existingOption) {
                                userSearchState.executable[ruleIndex].push({
                                    label: name,
                                    value: ref
                                });
                            } else {
                                // 更新現有選項的 label
                                existingOption.label = name;
                            }

                            return ref;
                        });
                    } else {
                        // 如果沒有選項，保持原始值
                        actorRef = refArray;
                    }
                }

                return {
                    actor_type: rule.actor_type,
                    actor_ref: actorRef
                };
            }) || [];

        // 處理獎勵
        formData.rewards =
            data.rewards?.map((reward) => {
                // 如果是經驗值獎勵，reference_id 應該是 'exp'
                if (reward.reward_type === 'exp') {
                    return {
                        reward_type: 'exp',
                        reference_id: 'exp',
                        value: reward.value
                    };
                }
                return {
                    reward_type: reward.reward_type || 'point',
                    reference_id: reward.reference_id,
                    value: reward.value
                };
            }) || [];

        // 如果有資料，則預設展開該區塊
        if (formData.visibility_rules.length > 0) {
            if (!sectionsActiveKeys.value.includes('visibility')) {
                sectionsActiveKeys.value.push('visibility');
            }
        }
        if (formData.executable_rules.length > 0) {
            if (!sectionsActiveKeys.value.includes('executable')) {
                sectionsActiveKeys.value.push('executable');
            }
        }
        if (formData.rewards.length > 0) {
            if (!sectionsActiveKeys.value.includes('rewards')) {
                sectionsActiveKeys.value.push('rewards');
            }
        }

        nextTick(() => {
            formRef.value?.clearValidate();
        });
    } catch (error) {
        handleHttpError(error, '載入章節資料');
        showErrorMessage('載入章節資料失敗');
    }
};

// 提交
const handleSubmit = async () => {
    try {
        await formRef.value.validate();

        // 統一處理提交資料格式
        const submitData = processSubmitData(formData, {
            fields: [
                'mission_id',
                'name',
                'description',
                'attribute',
                'is_active',
                'auto_complete',
                'is_trigger',
                'triggered_by_id',
                'unlock_from_node_id',
                'trigger_node_ids',
                'designated_collaborator',
                'start_time',
                'end_time',
                'rewards',
                'visibility_rules',
                'executable_rules'
            ],
            fieldDefaults: {
                unlock_from_node_id: null,
                triggered_by_id: null
            },
            deleteEmptyTime: true
        });

        if (editingChapterId.value) {
            await updateChapter(editingChapterId.value, submitData);
            message.success('更新章節成功');
        } else {
            await createChapter(submitData);
            message.success('新增章節成功');
        }

        isVisible.value = false;
        emit('success');
    } catch (error) {
        if (error.errorFields) {
            showErrorMessage('請填寫必填欄位');
            return;
        }
        handleHttpError(
            error,
            editingChapterId.value ? '更新章節' : '新增章節'
        );
        showErrorMessage(
            editingChapterId.value ? '更新章節失敗' : '新增章節失敗'
        );
    }
};

// 取消
const handleCancel = () => {
    resetForm();
    isVisible.value = false;
};

// Watch
// 監聽 editingId 變化（只在視窗關閉時重置表單，避免重複呼叫）
watch(
    () => props.editingId,
    (newId) => {
        if (!newId && !isVisible.value) {
            resetForm();
        }
    }
);

// 監聽 isVisible 變化（只在這裡載入資料，避免重複呼叫）
watch(isVisible, (newVal) => {
    if (newVal) {
        if (props.editingId) {
            loadData(props.editingId);
        } else {
            resetForm();
        }
    } else {
        resetForm();
    }
});

watch(
    () => props.missionId,
    (newId) => {
        formData.mission_id = newId;
    }
);
</script>

<style scoped>
/* 表單區塊摺疊面板樣式 */
.form-sections-collapse {
    background: transparent !important;
    border: none !important;
}

.form-sections-collapse :deep(.ant-collapse-item) {
    background: transparent !important;
    border: none !important;
    margin-bottom: 8px !important;
}

.form-sections-collapse :deep(.ant-collapse-header) {
    background: rgba(255, 255, 255, 0.95) !important;
    padding: 12px 16px !important;
    border: 1px solid rgba(42, 74, 122, 0.2) !important;
    border-radius: 12px !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1) !important;
    transition: all 0.3s ease !important;
}

.form-sections-collapse :deep(.ant-collapse-header:hover) {
    background: rgba(255, 255, 255, 1) !important;
    border-color: rgba(42, 74, 122, 0.4) !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.2) !important;
}

.form-sections-collapse :deep(.ant-collapse-content) {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
}

.form-sections-collapse :deep(.ant-collapse-content-box) {
    padding: 0 !important;
}

.form-section-card-inner {
    background: rgba(255, 255, 255, 0.95) !important;
    border: 1px solid rgba(42, 74, 122, 0.2) !important;
    border-radius: 0 0 12px 12px !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1) !important;
    margin-top: -8px !important;
    padding: 16px !important;
}

.section-header {
    font-family: 'Courier New', monospace;
    font-size: 14px;
    font-weight: 600;
    color: #2a4a7a;
}

.section-note {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    font-weight: normal;
}

/* 規則與獎勵樣式 */
.rules-section,
.rewards-section {
    width: 100%;
}

.rules-header,
.rewards-header {
    margin-bottom: 16px;
}

.rules-list,
.rewards-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.rule-item,
.reward-item {
    padding: 12px;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(42, 74, 122, 0.15);
    border-radius: 6px;
    transition: all 0.2s ease;
}

.rule-item:hover,
.reward-item:hover {
    border-color: rgba(42, 74, 122, 0.3);
    background: rgba(255, 255, 255, 0.7);
}

.delete-rule-btn {
    color: #ff4d4f;
}

/* 空狀態時減少 padding */
.form-section-card-inner:has(.no-rules) :deep(.ant-card-body),
.form-section-card-inner:has(.no-rewards) :deep(.ant-card-body) {
    padding: 4px 12px !important;
}

.no-rules,
.no-rewards {
    padding: 12px;
    text-align: center;
}

/* 隱藏空狀態的 image */
.no-rules :deep(.ant-empty-image),
.no-rewards :deep(.ant-empty-image) {
    display: none;
}

/* 節點選擇器樣式 */
.node-selector-display {
    padding: 8px 12px;
    background: rgba(42, 74, 122, 0.05);
    border: 1px solid rgba(42, 74, 122, 0.2);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    min-height: 40px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.node-selector-display:hover {
    background: rgba(42, 74, 122, 0.1);
    border-color: rgba(42, 74, 122, 0.4);
}

.node-selector-display.multiple {
    padding: 4px 8px;
}

.node-tag {
    margin: 0 !important;
}

.node-selector-btn {
    width: 100%;
    border-color: rgba(42, 74, 122, 0.3);
    color: #2a4a7a;
}

.node-selector-btn:hover {
    border-color: #2a4a7a;
    color: #2a4a7a;
}
</style>
